import Hls from 'hls.js';
import React, { useEffect, useRef, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import Loading from '../loading';
import dayjs from 'dayjs';

export default function Live() {
    const { matchId } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [dataLive, setDataLive] = useState({});
    const [listLive, setListLive] = useState();
    const [paging, setPaging] = useState({ current: 1, pageSize: 8 });
    const [isShowLoadMore, setIsShowLoadMore] = useState(false);
    const videoRef = useRef(null);
    const videoQc = useRef(null);
    useEffect(() => {
        fetchData();
    }, [matchId]);

    useEffect(() => {
        listDataLive();
        handleSeeMore();
    }, []);
    const fetchData = async () => {
        setIsLoading(true);
        try {
            const myHeaders = new Headers();
            myHeaders.append("Cookie", "SERVER=api1");

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
            };

            const response = await fetch(
                `https://api.553328.com/api/match-detail?matchId=${matchId}`,
                requestOptions
            );

            const data = await response.json();
            setDataLive(data?.value?.datas);
            scrollToTop();
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const listDataLive = async () => {
        setIsLoading(true);
        try {
            var myHeaders = new Headers();
            myHeaders.append("Cookie", "SERVER=api2");

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                redirect: 'follow'
            };
            const response = await fetch(
                `https://api.553328.com/api/get-livestream?current=${paging.current}&pageSize=${paging.pageSize}`,
                requestOptions
            );
            const data = await response.json();
            if (data?.value?.datas?.length === 0 || data?.value?.datas?.length < paging.pageSize);
            setIsShowLoadMore(true);
            setListLive(data?.value?.datas);
            setIsLoading(false);
        } catch (error) {
            console.error("Error list live", error)
        } finally {
            setIsLoading(false)
        }
    }
    const handleSeeMore = async () => {
        try {
            var myHeaders = new Headers();
            myHeaders.append("Cookie", "SERVER=api2");
            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                redirect: 'follow'
            };
            const response = await fetch(
                `https://api.553328.com/api/get-livestream?current=${paging.current}&pageSize=${paging.pageSize}`,
                requestOptions
            );
            const data = await response.json();
            if (data?.value?.datas?.length === 0 || data?.value?.datas?.length < paging.pageSize); {
                setIsShowLoadMore(true);
                const _paging = {
                    current: paging.current + 1,
                    pageSize: paging.pageSize
                };
                setPaging(_paging);
                setListLive([...listLive, ...data?.value?.datas]);
                setIsLoading(false);
            }

        } catch (error) {
            console.error("Error list live", error)
        } finally {
            setIsLoading(false)
        }
    };
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        const setupVideo = () => {
            if (videoRef.current && dataLive?.linkLive) {
                const videoSrc = dataLive.linkLive;
                try {
                    if (dataLive.linkLive !== null) {
                        if (Hls.isSupported()) {
                            const hls = new Hls();
                            console.log("HLS Supported:", hls);
                            hls.loadSource(videoSrc);
                            hls.attachMedia(videoRef.current);
                        } else if (
                            videoRef.current.canPlayType("application/vnd.apple.mpegurl")
                        ) {
                            console.log("HLS Not Supported - Using Alternative");
                            videoRef.current.src = videoSrc;
                        }
                    } else {
                        videoSrc = "https://media.553328.com/videos/luongson.m3u8";
                        if (Hls.isSupported()) {
                            const hls = new Hls();
                            console.log("HLS Supported:", hls);
                            hls.loadSource(videoSrc);
                            hls.attachMedia(videoRef.current);
                        } else if (
                            videoRef.current.canPlayType("application/vnd.apple.mpegurl")
                        ) {
                            console.log("HLS Not Supported - Using Alternative");
                            videoRef.current.src = videoSrc;
                        }
                    }
                } catch (error) {
                    console.error("HLS error", error);
                }
            }
        };

        setupVideo();
    }, [dataLive]);
    useEffect(() => {
        const setupVideoQc = () => {
            const videoSrc = 'https://customer-kr8gl4xkz7zjtk52.cloudflarestream.com/6576d4a600daa61bfcc0faa6551aff4f/manifest/video.m3u8';
            try {
                if (Hls.isSupported()) {
                  const hls = new Hls();
                  console.log("HLS Supported:", hls);
                  hls.loadSource(videoSrc);
                  hls.attachMedia(videoQc.current);
                } else if (
                  videoQc.current.canPlayType("application/vnd.apple.mpegurl")
                ) {
                  console.log("HLS Not Supported - Using Alternative");
                  videoQc.current.src = videoSrc;
                }
            } catch (error) {
              console.error("HLS error", error);
            }
        };
    
        setupVideoQc();
      }, [dataLive]);

    return (
        <>
                    <video
                        ref={videoRef}
                        autoPlay
                        controls
                        muted
                        width="100%"
                        height="100%"
                    />
            {isLoading ? <Loading /> : (
                <div className='container py-4 px-2 mx-auto w-full grid grid-cols-2 gap-2 sm:grid-cols-2 lg:mt-6 lg:gap-x-10 lg:gap-y-8 lg:grid-cols-3 xl:grid-cols-4 xl:px-0'>

                    {listLive?.map((item, index) => (
                        <Link to={`/live/${item.matchId}`} key={index} className="block z-10 w-full h-full border border-[#36a638] rounded-lg bg-[url('https://ok9.help/wp-content/uploads/2024/07/bgitem.webp')] bg-cover bg-no-repeat bg-center cursor-pointer transition-transform duration-300 hover:-translate-y-1">
                            <div className='flex items-center justify-between py-1 px-2 border-b border-[#36a638] w-full h-1/5'>
                                <p className='truncate text-white font-bold text-xs md:text-sm xl:text-base'>{item.leagueShortName}</p>
                                      {item.status === 0 ? (
                                    <></>
                                ) : (
                                    <>
                                    <div className='text-[11px] flex gap-1 bg-[#ff0000] text-white rounded px-1 pt-0.5 font-semibold lg:text-sm'>
                                        <div class="whitespace-nowrap">
                                            <div class="flex items-center justify-center gap-1 pb-0.5">
                                                <img src="https://ok9.help/wp-content/uploads/2024/07/live.webp" alt="" class="object-contain w-3.5"/>
                                                <span class="font-medium text-xs">LIVE</span>
                                            </div>
                                        </div>
                                    </div>
                                    </>
                                )}
                            </div>
                            <div className='flex items-center justify-center text-primary py-2 px-1 md:py-4 md:px-2 w-full'>
                                <div className='flex flex-col items-center justify-center w-1/3'>
                                    <div className='flex items-center w-8 h-8 md:w-14 md:h-14'>
                                        <img className='object-contain rounded-full w-full h-full bg-white' src={item.homeLogo} alt={item.homeName} />
                                    </div>
                                    <p className='text-white text-xs text-center truncate w-full mt-1'>{item.homeName}</p>
                                </div>
                                <div className='flex flex-col items-center justify-center w-1/3'>
                                    <div className='flex flex-col items-center justify-center text-xs gap-1 md:flex-row xl:text-base'>
                                        <span className='text-white whitespace-nowrap'>{dayjs.unix(item.matchTime).format('HH:mm')}</span>
                                        <span className='text-white whitespace-nowrap'>{dayjs.unix(item.matchTime).format('DD/MM')}</span>
                                    </div>
                                    <p className='font-bold text-white'>VS</p>
                                </div>
                                <div className='flex flex-col items-center justify-center w-1/3'>
                                    <div className='flex items-center w-8 h-8 md:w-14 md:h-14'>
                                        <img className='object-contain rounded-full w-full h-full bg-white' src={item.awayLogo} alt={item.awayName} />
                                    </div>
                                    <p className='text-white text-xs text-center truncate w-full mt-1'>{item.awayName}</p>
                                </div>
                            </div>
                            <div className='class="bg-neutral-900 flex items-center rounded-b-lg justify-center border-t border-[#36a638] w-full h-1/5"'>
                            <p className='truncate text-white font-bold text-xs md:text-sm xl:text-base py-2'>{item.commentator}</p>
                            </div>
                        </Link>
                    ))
                    }


                </div>
            )}
            {isShowLoadMore && (
                <div className="flex items-center justify-center xl:mt-10 pb-3">
                    <button className='inline uppercase cursor-pointer transition-transform duration-300 hover:-translate-y-1 h-auto bg-gradient-to-b from-[#36a638] to-[#36a638] rounded-lg border border-[#36a638] font-medium p-1 text-xl text-white item-center justify-center btnMatchHot' onClick={handleSeeMore}>
                       các trận đấu khác
                    </button>
                </div>
            )}
        </>
    )
}
